import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'sh-markdown-preview',
  imports: [CommonModule, MarkdownModule],
  template: `
    <div class="markdown-body">
      <markdown [data]="value || ''" [inline]="inline"></markdown>
    </div>
  `,
})
export class MarkdownPreviewComponent {
  @Input() value = '';
  @Input() inline = false;
}
